<template>
  <figure
    class="gallery-item group "
    :class="photo.aspectClass"
    :style="`
      aspect-ratio: ${photo.thumbnail.dimensions.width}/${photo.thumbnail.dimensions.height};
      flex-grow: ${imageAspectRatio}; /* All items can grow */
      flex-basis: ${flexBasisValue}%; /* Use the calculated flex-basis */
    `"
  >
    <img
      class="gallery-image"
      loading="lazy"
      src="@/assets/images/global/transparent-placeholder.png"
      :width="photo.thumbnail.dimensions.width"
      :height="photo.thumbnail.dimensions.height"
      alt=""
    >

    <div
      class="gallery-image-bg"
      :style="`background-image: url('${photo.thumbnail.url}');`"
    />

    <figcaption
      v-if="isPhotoInCart"
      class="cart-label"
    >
      <FontAwesomeIcon :icon="faCheck" />Added to Cart
    </figcaption>

    <div class="overlay">
      <FontAwesomeIcon
        :icon="faMagnifyingGlassPlus"
      />
    </div>
  </figure>
</template>

<script setup>

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
  isPhotoInCart: Boolean,
  photo: {
    type: Object,
    default: () => ({}),
  },
});

const imageAspectRatio = computed(() => {
  return props.photo.thumbnail.dimensions.width / props.photo.thumbnail.dimensions.height;
});

// Use useWindowSize from @vueuse/core for reactive window dimensions
const { width: windowWidth } = useWindowSize();

const BASE_FLEX_BASIS = computed(() => {
  if (windowWidth.value <= 768) {
    // Mobile: 1 item per row
    return 100; // Close to 100% to ensure single item
  } else {
    // Desktop: 3 items per row (or more, adjust as desired)
    return 30; // For approximately 3 items per row
  }
});

const flexBasisValue = computed(() => {
  // Multiply the calculated BASE_FLEX_BASIS by the image's aspect ratio
  // The result is still a percentage (e.g., 30 * 1.77 = 53.1%)

  if (windowWidth.value <= 768) {
    return 100;
  } else {
    return BASE_FLEX_BASIS.value * imageAspectRatio.value;
  }
});

</script>
